import axios from 'axios'
import { showFailToast, showSuccessToast } from 'vant'

// 获取API基础URL
const getBaseURL = () => {
  // 始终使用相对路径 /api
  // 开发环境通过 vue.config.js 中的 proxy 代理到后端
  // 生产环境通过 nginx 或其他方式代理
  return '/api'
}

const request = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000
})

request.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    const res = response.data
    // 返回完整的响应数据，让业务代码自行处理错误
    return res
  },
  error => {
    showFailToast(error.message || '网络错误')
    return Promise.reject(error)
  }
)

export default request
export { showSuccessToast, showFailToast }
